import { Components, Theme, ThemeOptions, alpha } from '@mui/material/styles';

const getAvatarTheme = (theme: Theme): ThemeOptions => {
  const avatarTheme: Components<Theme>['MuiAvatar'] = {
    defaultProps: {
      variant: 'circular',
    },
    styleOverrides: {
      root: {
        // Background color: M3/sys/light/secondary-container at 50% opacity
        backgroundColor: alpha(
          theme.palette.M3.sys.light['secondary-container'],
          0.5
        ), // #CBD5E1 at 50%
        // Circular shape with border radius from Figma
        borderRadius: '50%',
        overflow: 'clip',
        // Text styles for initials
        color: theme.palette.M3.sys.light['on-surface-variant'], // #4E5C79
        textAlign: 'center',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        // Default size (medium)
        ...theme.typography.M3.body.medium,
        width: theme.unit(10), // 40px
        height: theme.unit(10), // 40px
        fontSize: '14px',

        // ─────────────────────────────
        // SIZE VARIANTS
        // ─────────────────────────────
        '&.avatar-size-s': {
          width: theme.unit(8), // 32px
          height: theme.unit(8), // 32px
          fontSize: '12px',
          ...theme.typography.M3.body.small,
        },
        '&.avatar-size-m': {
          width: theme.unit(10), // 40px
          height: theme.unit(10), // 40px
          fontSize: '14px',
          ...theme.typography.M3.body.medium,
        },
        '&.avatar-size-l': {
          width: theme.unit(12), // 48px
          height: theme.unit(12), // 48px
          fontSize: '16px',
          ...theme.typography.M3.body.large, // Figma match: 16px, 400 weight
        },
        '&.avatar-size-xl': {
          width: theme.unit(14), // 56px
          height: theme.unit(14), // 56px
          fontSize: '18px',
          ...theme.typography.M3.label.large,
        },
      },
    },
  };

  return {
    components: {
      MuiAvatar: avatarTheme,
    },
  };
};

export default getAvatarTheme;
